import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import PropTypes from 'prop-types';
import GenericSelectInputField from '../../../commons/form-fields/GenericSelectInputField';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';

const CurrentAffiliationFormSection = () => {
    const form = useForm();
    const { values } = useFormState();
    const isCurrentlyEmployed = values.info?.resume?.isCurrentlyEmployed;
    const currentAffiliation =
        values.info?.resume?.professionalAffiliation?.affiliation;

    useEffect(
        () => () => form.change('info.resume.professionalAffiliation'),
        []
    );

    return (
        <div>
            {!isCurrentlyEmployed && isCurrentlyEmployed !== undefined && (
                <div>
                    <GenericSelectInputField
                        name={'info.resume.professionalAffiliation.affiliation'}
                        label={
                            'Please select your current professional affiliation.'
                        }
                        required
                        clearOnUnmount
                        options={[
                            {
                                label: 'Consultant',
                                value: 'Consultant',
                                key: 'Consultant',
                            },
                            {
                                label: 'Retired',
                                value: 'Retired',
                                key: 'Retired',
                            },
                            {
                                label: 'Other',
                                value: 'Other',
                                key: 'Other',
                            },
                        ]}
                    />
                    {currentAffiliation === 'Consultant' && (
                        <GenericTextAreaInputField
                            name={'info.resume.professionalAffiliation.clients'}
                            label={
                                'Without disclosing anything confidential, please confirm the name(s) of your clients.'
                            }
                            required
                            clearOnUnmount
                        />
                    )}

                    {currentAffiliation === 'Other' && (
                        <GenericTextAreaInputField
                            name={
                                'info.resume.professionalAffiliation.description'
                            }
                            label={
                                'Please describe your current employment status.'
                            }
                            required
                            clearOnUnmount
                        />
                    )}
                </div>
            )}
        </div>
    );
};

CurrentAffiliationFormSection.propTypes = {
    values: PropTypes.any,
};

export default CurrentAffiliationFormSection;
